import { render } from "./PaymentTypeSelector.vue?vue&type=template&id=c7a47180"
import script from "./PaymentTypeSelector.vue?vue&type=script&lang=js"
export * from "./PaymentTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__